module.exports = __webpack_public_path__ + "static/media/next-play-icon.57ac35af.svg";